export var CampaignUserType;
(function (CampaignUserType) {
    CampaignUserType[CampaignUserType["Dealer"] = 1] = "Dealer";
    CampaignUserType[CampaignUserType["Transporter"] = 2] = "Transporter";
})(CampaignUserType || (CampaignUserType = {}));
